import { atom } from "jotai";

// serverWakingAtom is set true when an API read sees the backend as unreachable
// (502/503/504) — the whole server is down, not one endpoint. On stg that is the
// 02:00–14:00 JST idle window where ace-api/hq/public-api are scaled to 0
// (scheduled_shutdown.tf); in prod it would be a real outage.
//
// The api layer flips it (getDefaultStore) from request(); ServerWakingOverlay
// reads it, CONFIRMS the outage via GET /health (so a single transient 5xx never
// shows the screen), renders a "reconnecting" overlay, and reloads once /health
// recovers so every read re-runs cleanly. The overlay clears the flag itself.
export const serverWakingAtom = atom(false);
